var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0",staticStyle:{"width":"1080px"}},[_c('v-breadcrumbs',{attrs:{"items":_vm.get_bcrumbs,"large":""},scopedSlots:_vm._u([{key:"divider",fn:function(){return [_c('v-icon',[_vm._v("mdi-chevron-right")])]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }